import { Box, Typography } from '@mui/material';

interface CustomNoRowsProps {
  title?: string;
  subtitle?: string;
}

const CustomNoRows = ({
  title = 'No Items found.',
  subtitle = 'Try adjusting your filters or adding new data.',
}: CustomNoRowsProps = {}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        {title}
      </Typography>
      <Typography color="text.secondary">{subtitle}</Typography>
    </Box>
  );
};

export default CustomNoRows;
